import * as React from 'react';
const SvgEmail = (props) => (
  <svg
    width={16}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.4}
      d="M0 3.41265C0 1.60664 1.43269 0.142578 3.2 0.142578H12.8C14.5673 0.142578 16 1.60664 16 3.41265V11.5878C16 13.3938 14.5673 14.8579 12.8 14.8579H3.2C1.43269 14.8579 0 13.3938 0 11.5878V3.41265Z"
      fill="currentColor"
    />
    <path
      d="M12.8 0.142578H3.2C1.43269 0.142578 0 1.60664 0 3.41265L6.00098 8.31856C7.16967 9.27399 8.83033 9.27399 9.99902 8.31856L16 3.41265C16 1.60664 14.5673 0.142578 12.8 0.142578Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgEmail;
